import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

/**
 * Lightweight raster (OpenStreetMap tiles) map via Leaflet.
 * No WebGL, no API key — renders on every browser.
 */
const LocationMap = ({ lat, lng, zoom = 16, height = { xs: 300, md: 400 } }) => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || !containerRef.current) return;

    const map = L.map(containerRef.current, {
      center: [lat, lng],
      zoom,
      scrollWheelZoom: false,
      attributionControl: true,
    });
    mapRef.current = map;

    map.attributionControl.setPosition('bottomleft');

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap',
    }).addTo(map);

    // Branded pin (SVG divIcon — no external image assets)
    const pin = L.divIcon({
      className: 'miran-pin',
      html:
        '<div style="width:26px;height:26px;border-radius:50% 50% 50% 0;' +
        'background:linear-gradient(135deg,#1565C0,#0D47A1);transform:rotate(-45deg);' +
        'border:3px solid #fff;box-shadow:0 6px 16px -4px rgba(13,71,161,0.8);"></div>',
      iconSize: [26, 26],
      iconAnchor: [13, 26],
    });
    L.marker([lat, lng], { icon: pin }).addTo(map);

    // Ensure correct sizing after mount
    setTimeout(() => map.invalidateSize(), 200);

    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, [lat, lng, zoom]);

  return <Box ref={containerRef} sx={{ width: '100%', height, zIndex: 0 }} />;
};

export default LocationMap;
